import React from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { useAuth } from '../context/AuthContext';

const BannerTwo = () => {
    const { isAuthenticated, isSubscribed } = useAuth();
    const settings = {
        dots: true,

        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,


    };

    // Set side navbar state
    const topicInfo = {"Attractions": "Attractions", "Beer / Drinks": "Beer / Drinks", "Accommodations": "Accommodations", "Coffee Shops": "Coffee Shops", "Dining": "Dining", "Retail": "Retail", "Transportation": "Transportation", "Golf / Mini": "Golf / Mini", "Tours / Excursions": "Tours / Excursions", "Spa / Health": "Spa / Health", "Museums": "Museums", "Misc": "Misc"}

    return (
        <div className="banner-two">
          <style>{`
            /* ===== BannerTwo Modern Styles ===== */

            .bn2-sidebar {
              border-radius: 0 !important;
              border: 1px solid #e2eaf3 !important;
              border-top: none !important;
              box-shadow: 0 4px 16px rgba(77, 168, 232, 0.1);
              overflow: hidden;
              background: #fff;
            }

            .bn2-category-link {
              transition: background 0.15s, color 0.15s, padding-left 0.15s;
            }
            .bn2-category-link:hover {
              background: #f0f7fd !important;
              color: #3a9de0 !important;
              padding-left: 22px !important;
            }
            .bn2-category-link:hover span:first-child {
              color: #3a9de0;
            }
            .bn2-view-all {
              background: #f0f7fd;
              border-bottom: 1px solid #e2eaf3;
              color: #2d86c8 !important;
              font-weight: 600;
            }
            .bn2-view-all:hover {
              background: #d9eefa !important;
              color: #1a6fab !important;
            }

            .bn2-slider-wrap {
              box-shadow: 0 4px 20px rgba(77, 168, 232, 0.18);
            }

            .bn2-btn {
              background-color: #4da8e8 !important;
              border-color: #4da8e8 !important;
              color: #fff !important;
              font-weight: 600;
              letter-spacing: 0.2px;
              transition: background 0.2s, box-shadow 0.2s, transform 0.15s !important;
            }
            .bn2-btn:hover {
              background-color: #3a9de0 !important;
              border-color: #3a9de0 !important;
              box-shadow: 0 6px 18px rgba(77, 168, 232, 0.38) !important;
              transform: translateY(-1px);
            }
          `}</style>
            <div className="container container-lg">
                <div className="banner-two-wrapper d-flex align-items-start">
                    <div className="w-265 d-lg-block d-none flex-shrink-0">
                        <div className="responsive-dropdown style-two common-dropdown nav-submenu p-0 submenus-submenu-wrapper position-relative border-top-0 bn2-sidebar">
                            <button
                                type="button"
                                className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                            >
                                <i className="ph ph-x" />{" "}
                            </button>
                            <div className="logo px-16 d-lg-none d-block">
                                <Link to="/" className="link">
                                    <img src="assets/images/logo/logo.png" alt="Logo" />
                                </Link>
                            </div>
                            <ul className="responsive-dropdown__list scroll-sm p-0 py-8 overflow-y-auto ">
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        state={null}
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 fw-semibold bn2-view-all"
                                    >
                                        <span>View All</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-squares-four" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Attractions"]}
                                    > 
                                        <span>Attractions</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Attractions
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Beer / Drinks"]}
                                    >
                                        <span>Beer / Drinks</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">Beer / Drinks</h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Accommodations"]}
                                    >
                                        <span>Accommodations</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            m
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Coffee Shops"]}
                                    >
                                        <span>Coffee Shops</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Coffee Shop
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Dining"]}
                                    >
                                        <span>Dining</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Dining
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Retail"]}
                                    >
                                        <span>Retail</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Retail
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Transportation"]}
                                    >
                                        <span>Transportation</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Transportation
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Golf / Mini"]}
                                    >
                                        <span>Golf / Mini</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Golf / Mini
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Tours / Excursions"]}
                                    >
                                        <span>Tours / Excursions</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Tours / Excursions
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Spa / Health"]}
                                    >
                                        <span>Spa / Health</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Spa / Health
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Museums"]}
                                    >
                                        <span>Museums</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {/* <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">Museum</h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0 bn2-category-link"
                                        state={topicInfo["Misc"]}
                                    >
                                        <span>Misc</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                </li>
                                {/* <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                                    >
                                        <span>Commercial Terminal</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Commercial Terminal
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                                    >
                                        <span>Headphone</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Headphone
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="has-submenus-submenu">
                                    <Link
                                        to="/shop"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                                    >
                                        <span>Smart Screen</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    <div className="submenus-submenu py-16">
                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                            Smart Screen
                                        </h6>
                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                            <li>
                                                <Link to="/shop">Samsung</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Iphone</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Vivo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Oppo</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Itel</Link>
                                            </li>
                                            <li>
                                                <Link to="/shop">Realme</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="banner-item-two-wrapper rounded-24 overflow-hidden position-relative arrow-center flex-grow-1 mb-0 bn2-slider-wrap">
                        <img
                            src="assets/images/bg/banner-two-bg-11.png"
                            alt=""
                            className="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
                        />
                        <div className="banner-item-two__slider">
                            <Slider {...settings}>
                                <div className="banner-item-two">
                                    <div className="banner-item-two__content">
                                        <span className="text-white mb-8 h6"></span>
                                        <h2 className="banner-item-two__title bounce" style={{ color: '#4da8e8' }}>
                                            Fun Card Deals & Coupons within your area
                                        </h2>
                                        <Link
                                            to="/cart"
                                            className="btn d-inline-flex align-items-center rounded-pill gap-8 mt-48 bn2-btn"
                                        >
                                            {isAuthenticated && isSubscribed ? 'Repurchase Fun Card' : 'Purchase Fun Card'}
                                            <span className="icon text-xl d-flex">
                                                <i className="ph ph-shopping-cart-simple" />
                                            </span>
                                        </Link>
                                    </div>
                                    <div className="position-absolute d-flex align-items-center justify-content-center gap-12" style={{ top: '50%', right: 0, width: '50%', transform: 'translateY(-50%)', padding: '0 24px' }}>
                                        {/* <img src="assets/images/thumbs/banner-example.png" alt="" style={{ width: '45%', height: 'auto', flexShrink: 0 }}/>
                                        <img src="assets/images/thumbs/banner-example.png" alt="" style={{ width: '45%', height: 'auto', flexShrink: 0 }}/> */}
                                    </div>
                                </div>
                                <div className="banner-item-two">
                                    <div className="banner-item-two__content">
                                        <span className="mb-8 h6" style={{ color: '#4da8e8' }}>Starting at only $30</span>
                                        <h2 className="banner-item-two__title bounce" style={{ color: '#4da8e8' }}>
                                            Start saving with Fun Card Coupons
                                        </h2>
                                        <Link
                                            to="/checkout"
                                            state="Newly Added Deals"
                                            className="btn d-inline-flex align-items-center rounded-pill gap-8 mt-48 bn2-btn"
                                        >
                                            Purchase Fun Card
                                            <span className="icon text-xl d-flex">
                                                <i className="ph ph-shopping-cart-simple" />
                                            </span>
                                        </Link>
                                    </div>
                                    <div className="banner-item-two__thumb position-absolute bottom-0">
                                        {/* <img src="assets/images/thumbs/banner-two-img2.png" alt="" /> */}
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BannerTwo